






























































import {
	AccountTypeEnum,
	PartyModel, PartyPrintModel, PartyPrintTypeEnum,
	QueryOperator,
	SortOrder,
	TenantModel,
	TenantUserModel,
	VisitRuleModel
} from '@/libs/Api';
import { visitRulesStore } from '@/libs/visit-rules/+state/store';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import Page from '@/Page.vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';

import VisitPlanDialog from '@/libs/parties/components/VisitPlanDialog.vue';
import { CrudQueryPredicate } from '@/libs/core/+state/models/crud-query-predicate';
import ExportDialog from '@/libs/common/components-smart/ExportDialog.vue';
import { Constants } from '@/constants';
import { authStore } from '@/libs/auth/+store/store';
import { AuthGetter } from '@/libs/auth/models/auth-state';
import { CrudDataStats } from '@/libs/core/+state/models/crud-data-stats';
import { CrudOrderBy } from '@/libs/core/+state/models/crud-order-by';
import {partiesStore} from "@/libs/parties/+state/store";
import ApiService from "@/libs/core/api-service";
import {b64toBlob} from "@/libs/common/functions/b64toBlob";
import {tenantsStore} from '@/libs/tenants/+state/store';

@Component({
    components: {
        VisitPlanDialog
    }
})
export default class PartyVisitPlan extends Page {

    pageInitialization = true;
    mobileFiltersShow = false;
    pageIndex = 1;
    pageSize = 25;
    sortBy = [ "displayName" ];
    sortDesc = [ false ];
	exporting = false;
    
    @Prop() tenantId!: string;
    @Prop() partyId!: string;

    get tableHeaders() {
        return [
            { text: this.$i18n.t("common.name"), value: "name", align: "left", sortable: false },
            { text: "Opakování", value: "fromTime", align: "left", sortable: false },
            { text: "Čas od", value: "fromTime", align: "left", sortable: false },
            { text: "Čas do", value: "toTime", align: "left", sortable: false },
			{ text: "Zahájení", value: "startDate", align: "left", width: "7%", sortable: false },
			{ text: "Ukončení", value: "endDate", align: "left", width: "7%", sortable: false },
            { text: "Poskytované úkony", value: "toTime", align: "left", sortable: false },
            { text: "", value: "", align: "right", sortable: false }
        ];
    }
    stateFilter: string | null = "";
    districtFilter: string | null = "";
    townFilter: string | null = "";
    userFilter: string | null = "";
	printing = false;

    get constants(): Constants {
        return Constants;
    }

    get loading(): boolean {
        return visitRulesStore.useGetter(CrudGetter.Pending);
    }

    get items(): VisitRuleModel[] {
        return [...visitRulesStore.useGetter(CrudGetter.Data)];
    }

    get totalRows(): number {
        const stats = visitRulesStore.useGetter(CrudGetter.DataStats) as CrudDataStats;
        return stats?.rowCount ?? 0;
    }

    get isAdmin (): boolean {
        const tenantUser = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
        return tenantUser.accountType == AccountTypeEnum.Admin;
    }

	get enableVisitPlanCreate (): boolean {
		const party = partiesStore.useGetter(CrudGetter.Detail) as PartyModel;
		const tenantUser = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
		const tenant = tenantsStore.useGetter(CrudGetter.Detail, this.tenantId) as TenantModel;
		return tenantUser.accountType == AccountTypeEnum.Admin || tenantUser.accountType == AccountTypeEnum.Manager || (tenantUser.accountType == AccountTypeEnum.Worker && tenant.enableEditClientByWorker == true && party.mainCareProviderId == tenantUser.userId) || (tenantUser.accountType == AccountTypeEnum.Worker && tenant.enableEditClientOfAnotherWorkers == true && party.districtId == tenantUser.mainDistrictId);
	}

    @Ref() dialog!: VisitPlanDialog;
    @Ref() exportDialog!: ExportDialog;

    @Watch("districtFilter")
    @Watch("townFilter")
    @Watch("stateFilter")
    @Watch("userFilter")
    filtersChanged (v: any, p: any) {
        this.pageIndex = 1;
        this.saveQuery();
        if (this.pageInitialization || this.isPageLocked())
            return;
        this.pageLock(this.$nextTick()).then(() => {
            this.loadItems();
        });
    }

    @Watch("pageIndex")
    @Watch("pageSize")
    paginationChanged () {
        this.saveQuery();
        if (this.pageInitialization || this.isPageLocked())
            return;
        this.pageLock(this.$nextTick()).then(() => {
            this.loadItems();
        });
    }

    @Watch("sortBy")
    @Watch("sortDesc")
    sortChanged () {
        this.saveQuery();
        if (this.pageInitialization || this.isPageLocked())
            return;
        this.pageLock(this.$nextTick()).then(() => {
            this.loadItems();
        });
    }

    @Watch("pageSize")
    pageSizeChanged () {
        this.pageIndex = 1;
    }

    created () {
        if (this.getQuery("state") != null || this.getQuery("user") != null || this.getQuery("district") != null || this.getQuery("town") != null || this.getQueryInt("pageSize") != null) {
            this.stateFilter = this.getQuery("state") ?? "";
            this.userFilter = this.getQuery("user") ?? "";
            this.districtFilter = this.getQuery("district") ?? "";
            this.townFilter = this.getQuery("town") ?? "";
            this.pageSize = this.getQueryInt("pageSize") ?? 25;
        }
        else {
            this.stateFilter = window.localStorage.ptState ?? "";
            this.userFilter = window.localStorage.ptUser ?? "";
            this.districtFilter = window.localStorage.ptDistrict ?? "";
            this.townFilter = window.localStorage.ptTown ?? "";
            if (window.localStorage.ptPageSize && Number(window.localStorage.ptPageSize)) {
                this.pageSize = Number(window.localStorage.ptPageSize);
            }
            this.saveQuery();
        }
    }

    mounted () {
        this.loadItems();
    }

    saveQuery () {
        this.setQuery("state", this.stateFilter);
        this.setQuery("user", this.userFilter);
        this.setQuery("district", this.districtFilter);
        this.setQuery("town", this.townFilter);
        this.setQuery("pageSize", this.pageSize?.toString());
        window.localStorage.ptState = this.stateFilter ?? "";
        window.localStorage.ptUser = this.userFilter ?? "";
        window.localStorage.ptDistrict = this.districtFilter ?? "";
        window.localStorage.ptTown = this.townFilter ?? "";
        window.localStorage.ptPageSize = this.pageSize?.toString();
    }

    clearFilters () {
        this.stateFilter = null;
        this.userFilter = null;
        if (this.isAdmin) {
            this.districtFilter = null;
        }
        this.townFilter = null;
        this.saveQuery();
    }

    loadItems () {
        const filters = this.getFilters();
        let orderBy: CrudOrderBy<VisitRuleModel>[] = [
            { field: 'fromTime', index: 1, order: 'asc' },
            { field: 'toTime', index: 2, order: 'asc' },
        ];
        // if (this.sortBy.contains("displayName")) {
        //     orderBy = [
        //         { field: "clientState.position", index: 1, order: "asc" },
        //         { field: "lastName", index: 2, order: this.sortDesc?.firstOrDefault() == true ? "desc" : "asc" },
        //         { field: "firstName", index: 3, order: this.sortDesc?.firstOrDefault() == true ? "desc" : "asc" }
        //     ];
        // }
        // else if (this.sortBy.contains("mainCareProvider.displayName")) {
        //     orderBy = [
        //         { field: "mainCareProvider.firstName", index: 1, order: this.sortDesc?.firstOrDefault() == true ? "desc" : "asc" },
        //         { field: "mainCareProvider.lastName", index: 2, order: this.sortDesc?.firstOrDefault() == true ? "desc" : "asc" }
        //     ];
        // }
        // else if (this.sortBy && this.sortBy?.firstOrDefault()) {
        //     orderBy = [
        //         { field: this.sortBy?.first(), index: 2, order: this.sortDesc?.first() == true ? "desc" : "asc" }
        //     ];
        // }
        // else {
        //     orderBy = [
        //         { field: "clientState.position", index: 1, order: "asc" },
        //         { field: "lastName", index: 2, order: this.sortDesc?.firstOrDefault() == true ? "desc" : "asc" },
        //         { field: "firstName", index: 3, order: this.sortDesc?.firstOrDefault() == true ? "desc" : "asc" }
        //     ];
        // }
		// debugger;
        visitRulesStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<VisitRuleModel>(orderBy, filters, {
            pageIndex: this.pageIndex,
            pageSize: this.pageSize
        }));
        this.subscribe(visitRulesStore, CrudReponse.GetAll).then(() => {
            this.pageInitialization = false;
        })
    }

    getFilters() {

        let filters: CrudQueryPredicate[] = [
            { field: "partyId", op: "eq", comparand: this.partyId }
        ];
        
        const tenantUser = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;

        // if (this.districtFilter && tenantUser.accountType == AccountTypeEnum.Admin)
        //     filters.push({ field: "districtId", op: "eq", comparand: this.districtFilter });
        
        // if (this.townFilter)
        //     filters.push({ field: "townId", op: "eq", comparand: this.townFilter });
        
        // if (this.stateFilter)
        //     filters.push({ field: "clientStateId", op: "eq", comparand: this.stateFilter });
        
        // if (this.userFilter)
        //     filters.push({ field: "mainCareProviderId", op: "eq", comparand: this.userFilter });

        return filters;

    }

    createItemClick () {
        this.dialog.open(null, this.partyId);
    }

    openItemClick (v: VisitRuleModel) {
        this.dialog.open(v.id, this.partyId);
    }

    getWeekDays(item: VisitRuleModel) {

      const weekDays = [];

      if (item.onMonday)
        weekDays.push("Po");

      if (item.onTuesday)
        weekDays.push("Út");

      if (item.onWednesday)
        weekDays.push("St");

      if (item.onThursday)
        weekDays.push("Čt");

      if (item.onFriday)
        weekDays.push("Pá");

      if (item.onSaturday)
        weekDays.push("So");

      if (item.onSunday)
        weekDays.push("Ne");

      return weekDays.join(", ");

    }

	exportClick () {
		const party = partiesStore.useGetter(CrudGetter.Detail) as PartyModel;
		this.exporting = true;
		ApiService.api.exportVisitRuleBatch(1, 99999, {
			orderby: [
				{
					field: "name",
					index: 1,
					order: SortOrder.Asc
				}
			],
			predicates: [
				{ field: "partyId", op: QueryOperator.Eq, comparand: this.partyId }
			]
		}, {
			headers: {
				FileName: encodeURIComponent(`Předpis návštěv klienta ${party.displayName}`)
			}
		}).then((x: any) => {
			this.exporting = false;
			const res = x.data;
			const blob = b64toBlob(res.returnValue.base64, res.returnValue.contentType);
			const link = document.createElement('a');
			link.href = window.URL.createObjectURL(blob);
			link.setAttribute('download', res.returnValue.filename!);
			document.body.appendChild(link);
			link.click();
			link.parentNode!.removeChild(link);
		}).catch(e => {
			console.error(e);
			this.exporting = false;
		});
	}

	printClick(): void {
		this.printing = true;
		const printModel = {
			printType: PartyPrintTypeEnum.VisitRules
		} as PartyPrintModel;
		ApiService.api.printParty(this.partyId, printModel).then((x: any) => {
			this.printing = false;
			const res = x.data;
			const blob = b64toBlob(res.returnValue.base64, res.returnValue.contentType);
			const link = document.createElement('a');
			link.href = window.URL.createObjectURL(blob);
			link.setAttribute('download', res.returnValue.filename!);
			document.body.appendChild(link);
			link.click();
			link.parentNode!.removeChild(link);
		}).catch(() => {
			this.printing = false;
		});
	}

}
